import { Routes } from '@angular/router';
import { devOnlyGuard } from '@guards/dev-only.guard';
import { noAuthGuard } from '@guards/no-auth.guard';
import { PublicLayoutComponent } from 'app/layout/public-layout/public-layout.component';
import { LoginComponent } from './login/login.component';
import { PortalAccessComponent } from './portal-access/portal-access.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ResetPasswordConfirmComponent } from './reset-password-confirm/reset-password-confirm.component';
import { UiKitComponent } from './ui-kit/ui-kit.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';

const routes: Routes = [
	{
		path: '',
		component: PublicLayoutComponent,
		children: [
			{
				path: '',
				redirectTo: 'login',
				pathMatch: 'full',
			},
			{
				path: 'login',
				component: LoginComponent,
				canActivate: [noAuthGuard],
			},
			{
				path: 'verify-email',
				component: VerifyEmailComponent,
				canActivate: [noAuthGuard],
			},
			{
				path: 'reset-password',
				component: ResetPasswordComponent,
				canActivate: [noAuthGuard],
			},
			{
				path: 'reset-password-confirm',
				component: ResetPasswordConfirmComponent,
			},
			// Link of the «Acceso al portal» email: set the password and enter the portal.
			{
				path: 'acceso-portal/:token',
				component: PortalAccessComponent,
			},
			{
				path: 'ui-kit',
				component: UiKitComponent,
				canActivate: [devOnlyGuard],
			},
		],
	},
];

export default routes;
